export default "__VITE_ASSET__bt6BgLJF__"